module.exports = __webpack_public_path__ + "static/media/video-yardnapha-off.eebdecb7.png";